module.exports = __webpack_public_path__ + "img/B4-20190410_03.853c07c1.jpg";